import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

export function mapHtmlBlock(
  input:
    | BlockHtmlParagraphFragment
    | BlockHtmlListFragment
    | BlockHtmlTableFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'formattedText'> {
  return {
    key: 'formattedText',
    input: () => [
      {
        Content: buildHtml(input.html),
      },
      200,
    ],
  };
}
